/**
 * @flow
 * @format
 */

import React from 'react';
import _ from 'lodash';
// import cc from 'classcat';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { withHandlers, compose, withState } from 'recompose';

import { actions as designActions } from '~/actions/design';
import designRoutines from '~/routines/design';
import {
  actions as modalActions,
  constants as modalConstants,
} from '~/actions/modal';
import { getDesignName, getCurrentRecordId } from '~/selectors/global';
import * as progressSelectors from '~/selectors/progress';

import type { HOC } from 'recompose';
// import type { Connector } from 'react-redux';

import RightToolBar from '../RightToolBar';
import LeftToolBar from '../LeftToolBar';

import classes from './DesignToolBar.scss';

type OwnPropsType = {};

type ReduxPropsType = {
  designName: string,
  disableAutoComplete: boolean,
  disableBack: boolean,
  disableNext: boolean,
  disableOpen: boolean,
  // disableRedo: boolean,
  disableReset: boolean,
  disableSave: boolean,
  // disableUndo: boolean,
  isSavedDesign: boolean,
};

type EnchancedPropsType = {
  onAutoComplete(): void,
  onNewDesign(): void,
  onOpen(): void,
  // onRedo(): void,
  onSave(): void,
  onStepBackward(): void,
  onStepForward(): void,
  onStepReset(): void,
  // onUndo(): void,
};

type PropsType = OwnPropsType & EnchancedPropsType & ReduxPropsType;

export class DesignToolBar extends React.PureComponent<PropsType, *> {
  props: PropsType;

  render() {
    return (
      <Col className={classes.navWrapper}>
        <div className="d-lg-flex justify-content-start">
          <LeftToolBar
            {..._.omit(this.props, ['disableReset', 'disableAutoComplete'])}
          />
          <RightToolBar {...this.props} />
        </div>
      </Col>
    );
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): ReduxPropsType & OwnPropsType {
  const designName: string = getDesignName(state);
  const id = getCurrentRecordId(state);
  const isSavedDesign = id !== null;

  return {
    ...ownProps,
    disableOpen: false,
    disableSave: false,
    disableNext: !progressSelectors.getNextEnabled(state),
    disableBack: !progressSelectors.getBackEnabled(state),
    disableReset: !progressSelectors.getResetEnabled(state),
    disableRename: false,
    disableAutoComplete: !progressSelectors.getAutocompleteEnabled(state),
    designName,
    isSavedDesign,
    id,
  };
}
// PropsType & { dispatch: Dispatch }
type HType = OwnPropsType & AppDispatch;
const enhancer: HOC<*, OwnPropsType> = compose(
  connect(mapStateToProps),
  // TODO: ___ FIX THIS ___ use title updater for contenteditable.
  withState('designTitle', 'setTitle', props => props.designName),
  withHandlers({
    onChangeDesignName: ({ setTitle }) => () => setTitle(s => s),
    onAutoComplete: (props: HType) => () =>
      props.dispatch(designActions.autoComplete()),
    onNewDesign: (props: HType) => () =>
      props.dispatch(designActions.newDesign()),
    onOpen: (props: HType) => () => props.dispatch(designActions.openDesign()),
    // onRedo: (props: HType) => () => props.dispatch(designActions.())),
    onSave: (props: HType) => () =>
      props.dispatch(
        modalActions.showModal({
          modalType: modalConstants.MODAL_SAVE_DESIGN,
          modalProps: {
            onSubmit: (data: string) =>
              props.dispatch(designRoutines.saveDesignRecord(data)),
            // onUpdate: (data: string) =>
            //   props.dispatch(designRoutines.updateDesignRecord(data)),
          },
        }),
      ),
    // onManage: (props: HType) => () =>
    //   props.dispatch(
    //     modalActions.showModal({
    //       modalType: modalConstants.MODAL_FILE_MANAGE,
    //       modalProps: {
    //         onDelete: (id: number) => console.log('deleting: ', id),
    //         onRename: (id: number, newName: string) =>
    //           console.log('renaming', id, 'to', newName),
    //       },
    //     }),
    //   ),
    onStepBackward: (props: HType) => () =>
      props.dispatch(designActions.stepBackward()),
    onStepForward: (props: HType) => () =>
      props.dispatch(designActions.stepForward()),
    onStepReset: (props: HType) => () =>
      props.dispatch(designActions.stepReset()),
    // onUndo: (props: HType) => () => props.actions.()),
    onDuplicateDesign: (props: HType) => id =>
      props.dispatch(
        designRoutines.copyDesign({
          id,
          name: `${props.designName}-${new Date().toISOString()}`,
        }),
      ),
    onUpdateDesign: (props: HType) => () =>
      props.dispatch(designRoutines.updateDesign({ id: props.id })),
  }),
);

export default enhancer(DesignToolBar);



// WEBPACK FOOTER //
// ./src/components/DesignToolBar/DesignToolBar.js